import {myopAttributes} from "../../consts.ts";
import {Ref} from "../../messages";

export const getElementsByRef = (ref: Ref, el: ParentNode) => {
    return el.querySelectorAll(`[${myopAttributes.id}='${ref.refConfig.selector}']`);
}

export const getFirstElementByRef = (ref: Ref, el: ParentNode) => {
    const elements = getElementsByRef(ref, el);
    if (elements.length) {
        return elements.item(0);
    }
    return null;
}